import React, { useMemo } from 'react';

import { formatNumber } from '../../services/csvDataService';
import {
	PLAYER_SORT_AVERAGE,
	PLAYER_SORT_QUILLES,
	sortPlayerRows,
	truncateDisplayLabel,
} from '../../utils/newResultsTeamSort';
import SortableTeamNumHeader from './SortableTeamNumHeader';

export default function PlayersRankingTable({
	players,
	onSelectPlayer,
	rankOffset = 0,
	sortColumn,
	onSortColumn,
	hideLicenseColumns = false,
	showSeasonCount = false,
}) {
	const sortedPlayers = useMemo(
		() => sortPlayerRows(players, sortColumn),
		[players, sortColumn],
	);

	if (!sortedPlayers.length) {
		return <p className="new-results-hint">Aucun joueur pour ce contexte.</p>;
	}

	return (
		<div className="new-results-table-scroll new-results-table-scroll--players">
			<table className="new-results-table new-results-table--players">
			<thead>
				<tr>
					<th className="new-results-rank new-results-players-col-rank">#</th>
					<th className="new-results-num new-results-players-col-licence">N° Licence</th>
					<th className="new-results-players-col-joueur">Joueur</th>
					<th className="new-results-players-col-club">Club</th>
					{!hideLicenseColumns && (
						<th className="new-results-num new-results-players-col-cl">CL</th>
					)}
					{!hideLicenseColumns && (
						<th className="new-results-num new-results-players-col-tl">TL</th>
					)}
					<th className="new-results-num new-results-players-col-manches" aria-label="Manches">
						<span className="new-results-th-label-full">Manches</span>
						<span className="new-results-th-label-short">NB</span>
					</th>
					{showSeasonCount && (
						<th className="new-results-num new-results-players-col-saisons">Saisons</th>
					)}
					<SortableTeamNumHeader
						label="Quilles"
						labelContent={(
							<>
								<span className="new-results-th-label-full">Quilles</span>
								<span className="new-results-th-label-short">Quil.</span>
							</>
						)}
						sortKey={PLAYER_SORT_QUILLES}
						activeSort={sortColumn}
						onSort={onSortColumn}
						className="new-results-players-col-quilles"
					/>
					<SortableTeamNumHeader
						label="Moyenne"
						labelContent={(
							<>
								<span className="new-results-th-label-full">Moyenne</span>
								<span className="new-results-th-label-short">Moy.</span>
							</>
						)}
						sortKey={PLAYER_SORT_AVERAGE}
						activeSort={sortColumn}
						onSort={onSortColumn}
						className="new-results-players-col-moyenne"
					/>
				</tr>
			</thead>
			<tbody>
				{sortedPlayers.map((p, idx) => {
					const rank = rankOffset + idx + 1;
					const mobileMetaTitle = [p.licence, p.club].filter(Boolean).join(' · ');
					const mobileMeta = [p.licence, truncateDisplayLabel(p.club)].filter(Boolean).join(' · ');
					return (
						<tr key={p.licence} onClick={() => onSelectPlayer(p.licence)}>
							<td className={`new-results-rank new-results-players-col-rank ${rank <= 3 ? 'new-results-rank--top' : ''}`}>{rank}</td>
							<td className="new-results-num new-results-players-col-licence">{p.licence}</td>
							<td className="new-results-players-col-joueur">
								<span className="new-results-players-name" title={p.playerName}>
									<span className="new-results-players-name-full">{p.playerName}</span>
									<span className="new-results-players-name-short">{truncateDisplayLabel(p.playerName)}</span>
								</span>
								<span className="new-results-players-club-snippet" title={mobileMetaTitle || undefined}>
									{mobileMeta}
								</span>
							</td>
							<td className="new-results-players-col-club">{p.club}</td>
							{!hideLicenseColumns && (
								<td className="new-results-num new-results-players-col-cl">{p.licenceCategory || '—'}</td>
							)}
							{!hideLicenseColumns && (
								<td className="new-results-num new-results-players-col-tl">{p.licenceLevel || '—'}</td>
							)}
							<td className="new-results-num new-results-players-col-manches">{formatNumber(p.manches)}</td>
							{showSeasonCount && (
								<td className="new-results-num new-results-players-col-saisons">{formatNumber(p.seasons)}</td>
							)}
							<td className={`new-results-num new-results-players-col-quilles ${sortColumn === PLAYER_SORT_QUILLES ? 'new-results-num--highlight' : ''}`}>
								{formatNumber(p.quilles)}
							</td>
							<td className={`new-results-num new-results-players-col-moyenne ${sortColumn === PLAYER_SORT_AVERAGE ? 'new-results-num--highlight' : ''}`}>
								{formatNumber(p.average, 2)}
							</td>
						</tr>
					);
				})}
			</tbody>
			</table>
		</div>
	);
}
